export default __webpack_public_path__ + "static/blagodia-e5510763a6a57544248ecc81a89e033a.svg";